import React, { ReactNode } from 'react';

/**
 * FragmentWrapper - A simpler alternative to React.Fragment for React 19
 *
 * Problem: React 19 Fragments reject any props except 'key' and 'children',
 * but React Router passes location/match/history through the tree.
 *
 * Solution: Accept all props, but only use children. Everything else is ignored.
 * This is more explicit than Fragment and compatible with React 19.
 */

interface FragmentWrapperProps {
  children: ReactNode;
}

export const FragmentWrapper = ({ children }: FragmentWrapperProps) => {
  return <>{children}</>;
};
